
  <h2 mat-dialog-title class="{{cssClass()}}">
    {{data.titol}}
  </h2>
  <mat-dialog-content class="text-dialog">
    {{data.text}}
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close *ngIf="data.botoCancelar" >Cancel·lar</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial *ngIf="data.botoAcceptar">Acceptar</button>
  </mat-dialog-actions>
  <mat-spinner *ngIf="data.showSpin" style="margin:0 auto;" mode="indeterminate"></mat-spinner>

